var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcoConscious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.99 19.71c-4.966-3.892-17.95-3.18-17.95-3.18.295-.078.477-.156 1.5-.41 6.235-1.544 15.184-1.373 19.61 4.71a.996.996 0 0 0 1.4.2.984.984 0 0 0 .2-1.4 14.913 14.913 0 0 0-3.51-3.38C45.13 6.593 37.95 4.164 31.83 6.17 20.49 9.69 16.49 21.82 16.32 22.33a1.001 1.001 0 0 0 1.46 1.17c5.61-3.31 13.89.03 14.03.08 4.95 1.936 10.537.494 13.18-3.87zM30.04 55.39c-5.67-3.21-6.92-12.05-6.94-12.2-.72-3.61-2.32-6.25-4.77-7.84a10.503 10.503 0 0 0-5.19-1.63 11.245 11.245 0 0 0-.12 2c.15 4.879 5.71 14.51 5.71 14.51-3.384-3.57-6.273-7.6-7.1-12.99a12.897 12.897 0 0 1 .91-6.83 1 1 0 0 0-1.84-.78 14.784 14.784 0 0 0-1.17 4.74c-.56.43-1.07.86-1.55 1.31-6.606 5.935-3.743 12.92.02 16.2 5.24 4.84 11.84 5.84 16.4 5.84a26.889 26.889 0 0 0 5.36-.49 1.003 1.003 0 0 0 .28-1.84zM53.26 28.15a1.006 1.006 0 0 0-1.74.68c.04 3.89-2.46 7.42-4.5 9.65a2.485 2.485 0 0 0-1.11 1.15c-3.383 2.786-5.726 5.66-5.89 9.35a10.474 10.474 0 0 0 1.19 5.3 10.297 10.297 0 0 0 1.79-.89c3.786-2.315 9.82-12.58 9.82-12.58-.08.31-.22.83-.44 1.51-1.646 5.11-4.805 10.952-10.41 13.27a12.482 12.482 0 0 1-3.33.87 1.017 1.017 0 0 0-.87 1.12.998.998 0 0 0 1.11.87 15.027 15.027 0 0 0 4.69-1.35 16.517 16.517 0 0 0 6.08 1.36c6.564.184 9.503-6.371 9.85-8.8 2.63-11.58-5.87-21.11-6.24-21.51z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcoConscious);
export default __webpack_public_path__ + "static/media/Eco_Conscious.23d3e9ea05efc9136cf487cc552fbae4.svg";
export { ForwardRef as ReactComponent };